export default __webpack_public_path__ + "images/models/3b017bda7f0dd448b4adc69968e7b4b8.glb";